import { getLocale } from "../runtime";

const sv_iconshoppingcartadd = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Lägg till i varukorgen`
};

const iconshoppingcartadd = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_iconshoppingcartadd(inputs)
	return "iconShoppingCartAdd";
};

export { iconshoppingcartadd as "iconShoppingCartAdd" };